import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import Input from '@/components/Input';
import Button from '@/components/Button';
import { ToggleSwitch } from "@/components/ToggleSwitch";
import rem from '@/utils/rem.js'
import { ReactComponent as IconSourceSystem } from '@/assets/svgs/source-system-default.svg';

export const CreateSourceSystemModal = ({
    visible,
    hide,
    handleSubmit
}) => {
    const { t } = useTranslation();
    const [name, setName] = useState("");
    const [isDefault, setIsDefault] = useState(false);

    useEffect(() => {
        setName("");
        setIsDefault(false);
    }, [visible])

    return (
        <Modal visible={visible} variant="medium" close={hide}>
            <CardConfigure >
                <CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
										<div className="DS__icon--theme">

										<IconSourceSystem />
										</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Add Source System
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
                </CardConfigure.Header>
                <CardConfigure.Body>
                    <CardConfigure.Body.Col>
                        <div className="create-source-system">
                            <div className="create-source-system__title">Name of Source System</div>
                            <Input
                                name="ss-name-input"
                                id="ss-name-input"
                                data-testid="ss-name-input"
                                placeholder={t("Enter Source System Name")}
                                onChange={(e) => { setName(e.target.value) }}
                                value={name}
                                autoComplete="off"
                            />
                            <div className="flex-box flex-center flex-align-center create-source-system__default">
                                <div style={{ marginRight: rem(12) }}>Set as default Source System</div>
                                <ToggleSwitch
                                    data-testid="source-system-toggle"
                                    item={{ checked: isDefault }}
                                    labelText={null}
                                    callback={() =>
                                        setIsDefault(
                                            !isDefault
                                        )
                                    }
                                />
                            </div>
                        </div>
                    </CardConfigure.Body.Col>
                </CardConfigure.Body>
                <CardConfigure.Footer>
                    <CardConfigure.Footer.Left>
                        <Button
                            customeHover
                            btnText
                            id="create-ss-modal-cancel-btn"
                            text="Cancel"
                            submit={() => {
                                hide();
                            }}
                        />
                    </CardConfigure.Footer.Left>
                    <CardConfigure.Footer.Right>
                        <Button
                            round
                            text="Confirm"
                            id="create-ss-modal-confirm-btn"
                            data-testid="create-ss-modal-confirm-btn"
                            disabled={name.trim().length === 0}
                            submit={() => {
                                handleSubmit(name, isDefault);
                            }} />
                    </CardConfigure.Footer.Right>
                </CardConfigure.Footer>
            </CardConfigure>
        </Modal>
    )
};
